module.exports = __webpack_public_path__ + "media/images/lp/industries/issue_nursing-f02318b5ce38ca12f8c544367cfaab92.svg";